import React from "react";
import { Outlet } from "react-router-dom";

function AuthLayout() {
  return (
    <div className="w-full h-max flex items-center justify-center bg-light">
      <Outlet />
    </div>
  );
}

export default AuthLayout;
